<template>
  <v-app-bar absolute app color="transparent" flat height="75" style="width: auto">
    <img src="/static/logo2.png" style="max-width: 100px" />

    <v-spacer />

    <health-status-icon></health-status-icon>
    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          {{ currentUserName }}
          <v-icon right>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" flat nav>
        <v-list-item @click.prevent="editProfile" class="tile">
          <v-list-item-title v-text="$t('EditProfile')" />
        </v-list-item>

        <v-divider class="mb-2 mt-2" />
        <v-list-item @click.prevent="logout" class="tile">
          <v-list-item-title v-text="$t('Logout')" />
        </v-list-item>
      </v-list>
    </v-menu>
    <UserModal :ref="profileModalKey" @on-item-saved="onProfileSaved" />
  </v-app-bar>
</template>

<script>
import UserModal from '@/components/administration/user/UserModal.vue';
import HealthStatusIcon from '@/components/core/HealthStatusIcon';
export default {
    name: 'AppCoreAdminAppBar',

    components: {
        UserModal,
        HealthStatusIcon
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        profileModalKey: 'profileModal',
    }),
    computed: {
        currentUserName() {
            return (
                this.$store.getters['account/user'].Surname +
                ',' +
                this.$store.getters['account/user'].Name
            );
        },
        profileModal() {
            return this.$refs[this.profileModalKey];
        },
    },

    methods: {
        editProfile() {
            this.profileModal.edit(this.$store.getters['account/user']);
        },
        onProfileSaved() {
            Promise.all([
                this.$store.dispatch('account/getUser')
                    .then(() => this.$store.dispatch('account/postCulture'))
                    .then(() => this.$store.dispatch('account/getLocalization')),
                this.$store.dispatch('account/getUserMenu'),
                this.$store.dispatch('account/getOperators'),
                this.$store.dispatch('account/getStandardFields'),
            ]).finally(() => {
                location.reload();
            });
        },
        logout() {
            window.getApp.$emit('APP_LOGOUT');
        },
    },
};
</script>
<style scoped>
.tile:hover {
  background: lightgrey;
}
</style>